import styled from 'styled-components';

import Modal, { ModalSize } from 'components/modal';
import Picture from 'components/picture';

export const StyledModal = styled(Modal).attrs({ size: ModalSize.SMALL })`
  display: flex;
  align-items: center;
  padding: 4rem 3.25rem calc(3.5rem + env(safe-area-inset-bottom));
  height: 100%;
  && {
    flex-direction: column;
  }
  ${Styles.mobileTiny`
    padding: 2rem 3.75rem 1.5rem;
  `}
`;

export const Header = styled.h1`
  font-family: ${Styles.fontFamily.brand};
  font-size: 2rem;
  line-height: 1;
  text-align: center;
  margin: 0;
  width: 200px;
  letter-spacing: 0.8px;
  ${Styles.mobileTiny`
    font-size: 1.75rem;
  `}
`;

export const ItemText = styled(Header)`
  font-size: 1.25rem;
  ${Styles.mobileTiny`
    font-size: 1rem;
  `}
`;

export const Body = styled.p`
  text-align: center;
  margin: 0.5rem 0;
`;

export const StyledPicture = styled(Picture)`
  height: 10rem;
  width: 10rem;
  margin: 1.5rem 0;
  ${Styles.mobileTiny`
    margin: 1rem 0;
  `}
`;

export const ButtonContainer = styled.div`
  margin-top: auto;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  align-items: center;
`;
